import { css } from '@emotion/core';
import Button from '../../../components/Button';
import CancelButton from '../../../components/CancelButton';

function Footer({ disableSubmit, onCancel, onSubmit, cancelLabel, submitLabel }) {
    return (
        <>
            <div
                css={css`
                    display: flex;
                    justify-content: flex-end;
                    gap: 1.667rem;
                    margin-top: 3.333rem;

                    > button {
                        width: initial;
                        min-width: 8.333rem;
                    }
                `}
            >
                {cancelLabel && <CancelButton label={cancelLabel} onClick={onCancel} />}
                <Button disabled={disableSubmit} onClick={onSubmit}>
                    {submitLabel}
                </Button>
            </div>
        </>
    );
}

export default Footer;
